export default __webpack_public_path__ + "media/images/features/toyono/toyono_logo-3f5cb9899cd83d5928b697d25fb7ccf1.png";